import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=470830a5&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Social: require('/var/www/components/social/social.vue').default,Footer: require('/var/www/components/Footer/footer.vue').default})
